import { render, staticRenderFns } from "./AddressExtraInfoModal.vue?vue&type=template&id=559e83ac&scoped=true&"
import script from "./AddressExtraInfoModal.vue?vue&type=script&lang=js&"
export * from "./AddressExtraInfoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "559e83ac",
  null
  
)

export default component.exports